if (!customElements.get('okhomes-hero-crossfade')) {
  customElements.define('okhomes-hero-crossfade', class extends HTMLElement {
    connectedCallback() {
      this.image = this.querySelector('.okhomes-home-map__hero-alternate');
      this.button = this.querySelector('.okhomes-hero-crossfade__pause');
      if (!this.image || !this.button) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.ready = false;
      this.paused = false;
      this.visible = true;
      this.interval = Math.max(5, Number(this.dataset.interval) || 7) * 1000;
      this.button.addEventListener('click', () => {
        this.paused = !this.paused;
        this.button.textContent = this.paused ? 'Reanudar' : 'Pausar';
        this.button.setAttribute('aria-label', this.paused ? 'Reanudar alternancia de imágenes' : 'Pausar alternancia de imágenes');
        this.schedule();
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.classList.remove('is-alternate');
        this.button.hidden = !this.ready || this.motion.matches;
        this.schedule();
      }, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.schedule();
        });
        this.observer.observe(this);
      }
      const loaded = async () => {
        try { if (this.image.decode) await this.image.decode(); } catch { return; }
        if (!this.isConnected || !this.image.naturalWidth) return;
        this.ready = true;
        this.button.hidden = this.motion.matches;
        this.schedule();
      };
      if (this.image.complete) loaded();
      else this.image.addEventListener('load', loaded, { ...options, once: true });
    }
    schedule() {
      window.clearTimeout(this.timer);
      if (!this.ready || this.paused || this.motion.matches || document.hidden || !this.visible) return;
      this.timer = window.setTimeout(() => {
        this.classList.toggle('is-alternate');
        this.schedule();
      }, this.interval);
    }
    disconnectedCallback() {
      window.clearTimeout(this.timer);
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
}
